// extracted by mini-css-extract-plugin
module.exports = {"logo":"image_logo__1OUo3","title":"image_title__2Tmbk"};